// Testi dell'interfaccia. La fonte dei dati è i18n.json, così anche gli
// script di build (pre-rendering SEO) possono leggerli senza bundler.
import data from "./data/i18n.json";

export const translations = data;
